import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useUploadDocumentModal } from '../context/UploadDocumentModalContext';

const UploadDocumentModalFooter: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useUploadDocumentModal();

  const buttonDisabled = !data.name || !data.file || !data.date;

  return (
    <Modal.Footer>
      <button
        type="submit"
        className="btn btn-lg btn-primary"
        disabled={buttonDisabled}
        onClick={actions.handleUploadDocument}
      >
        {t('UpDocument')}
      </button>
    </Modal.Footer>
  );
};

export default UploadDocumentModalFooter;
